import React from 'react'
import './style.styl'
import Icon from 'svg-inline-react'
import EMPTY_VIEW from '!svg-inline?removeTags=true!images/live/live-view-empty.svg'

const NoCompanyInfo = () => {
  return (
    <div className="no-company-info-container">
      <div className="no-company-info-icon-container">
        <Icon className="no-company-info-icon" src={EMPTY_VIEW}/>
      </div>
      <div className="no-company-info-text">We don't have any company data<br/>for this person</div>
    </div>)
}


export default NoCompanyInfo



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyInfo/NoCompanyInfo/index.js